import FilterableFileList from "../filterableFileList/FilterableFileList";
import HashArgumentHelper from "../filterableFileList/HashArgumentHelper";
import HashArgumentObserver from "../filterableFileList/HashArgumentObserver";
import MobileFilterOverlay from "../filterableFileList/MobileFilterOverlay";
import { onDomReady } from "../../utils/on-dom-ready";

const filterTypes = {
  FILTER: "filter",
  SECTOR: "sector",
};

onDomReady(() => {
  const fileListContainer = document.querySelector(
    ".tx_baureihen_fileListContainer"
  );
  if (
    fileListContainer instanceof HTMLElement &&
    !fileListContainer.dataset.filelistinitialized
  ) {
    const fileList = new FilterableFileList(fileListContainer, {
      fileListSelector: ".tx_baureihen-fileList",
      filterSets: [
        {
          container: ".tx_baureihen_filterContainer",
          type: filterTypes.FILTER,
          elements: ".tx_baureihen-filter",
          defaultElement: ".tx_baureihen-filter--default",
          exclusive: false,
          combinationMode: "AND",
        },
        {
          container: ".tx_baureihen_sectorContainer",
          type: filterTypes.SECTOR,
          elements: ".tx_baureihen-filter",
          defaultElement: ".tx_baureihen-filter--default",
          exclusive: false,
        },
      ],
      itemsSelector: ".tx_baureihen--item",
      noResultsSelector: ".tx_baureihen--noResults",
      resetSelector: ".tx_baureihen--resetSelection",
      isotope: {
        layoutMode: "vertical",
      },
    });

    const hashArgumentHelper = new HashArgumentHelper(
      window.location,
      filterTypes.FILTER,
      filterTypes.SECTOR
    );
    hashArgumentHelper.convertLegacyUrl();

    const hashArgumentObserver = new HashArgumentObserver(hashArgumentHelper);

    const observers = [hashArgumentObserver];
    // Feature flag (dark launch): the new mobile filter is only enabled off-live
    // via the data-mobile-filter attribute rendered by the isLive ViewHelper.
    if (fileListContainer.dataset.mobileFilter === "1") {
      const mobileFilter = new MobileFilterOverlay(fileListContainer, {
        sheetSelector: ".baureihen-filter-sheet",
        labels: {
          open: fileListContainer.dataset.filterLabelOpen || "",
          apply: fileListContainer.dataset.filterLabelApply || "",
          close: fileListContainer.dataset.filterLabelClose || "",
        },
        fileList,
      });
      observers.push(mobileFilter.createCountObserver());
    }

    fileList.init(observers).then(() => {
      const categoryFilter = hashArgumentHelper.getFilter(filterTypes.FILTER);
      if (categoryFilter !== null) {
        categoryFilter.forEach((filter) => {
          fileList.setFilterState(filterTypes.FILTER, filter, true, true);
        });
      }
      const tagFilter = hashArgumentHelper.getFilter(filterTypes.SECTOR);
      if (tagFilter !== null) {
        tagFilter.forEach((filter) => {
          fileList.setFilterState(filterTypes.SECTOR, filter, true, true);
        });
      }
    });
  }
});
